import {
  Austria,
  Croatia,
  Denmark,
  Europe,
  France,
  Germany,
  Italy,
  Netherlands,
  Norway,
  Poland,
  Spain,
  Sweden,
  Uk,
  Usa,
} from '@awazevr/design-system.components.flags'
import type { LanguageOption } from './languageSelector'

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  {
    locale: 'da-DK',
    languageLabel: 'Dansk',
    currencyLabel: 'DKK',
    flag: Denmark,
  },
  {
    locale: 'de-AT',
    languageLabel: 'Deutsch (Österreich)',
    currencyLabel: 'EUR',
    flag: Austria,
  },
  {
    locale: 'de-DE',
    languageLabel: 'Deutsch',
    currencyLabel: 'EUR',
    flag: Germany,
  },
  {
    locale: 'en-GB',
    languageLabel: 'English (UK)',
    currencyLabel: 'GBP',
    flag: Uk,
  },
  {
    locale: 'en-US',
    languageLabel: 'English (US)',
    currencyLabel: 'USD',
    flag: Usa,
  },
  {
    locale: 'en-EU',
    languageLabel: 'English (EU)',
    currencyLabel: 'EUR',
    flag: Europe,
  },
  {
    locale: 'es-ES',
    languageLabel: 'Español',
    currencyLabel: 'EUR',
    flag: Spain,
  },
  {
    locale: 'fr-FR',
    languageLabel: 'Français',
    currencyLabel: 'EUR',
    flag: France,
  },
  {
    locale: 'hr-HR',
    languageLabel: 'Hrvatski',
    currencyLabel: 'EUR',
    flag: Croatia,
  },
  {
    locale: 'it-IT',
    languageLabel: 'Italiano',
    currencyLabel: 'EUR',
    flag: Italy,
  },
  {
    locale: 'nl-NL',
    languageLabel: 'Nederlands',
    currencyLabel: 'EUR',
    flag: Netherlands,
  },
  {
    locale: 'nb-NO',
    languageLabel: 'Norsk',
    currencyLabel: 'NOK',
    flag: Norway,
  },
  {
    locale: 'pl-PL',
    languageLabel: 'Polski',
    currencyLabel: 'PLN',
    flag: Poland,
  },
  {
    locale: 'sv-SE',
    languageLabel: 'Svenska',
    currencyLabel: 'SEK',
    flag: Sweden,
  },
]
